import { useQuery } from '@tanstack/react-query'
import { repository } from '../../data'
import { Panel, Section } from '../primitives'
import { Link } from '../shell/Link'

/**
 * On a technician's Today, one thing: the job to pick up. Your own job under
 * way if there is one, else a build with parts ready, else nothing to do —
 * each with one button. The full list is Work's.
 */
export function NextJob({ meId }: { meId: string }): JSX.Element | null {
  const work = useQuery({ queryKey: ['work', false], queryFn: () => repository.work(false) })
  const orders = useQuery({ queryKey: ['build-orders'], queryFn: () => repository.buildOrders() })
  if (!work.isSuccess || !orders.isSuccess) return null

  const mine = work.data.find((r) => r.performedBy === meId)
  const ready = orders.data.find((o) => o.state === 'released' && o.ready > 0)

  return (
    <Section label="Your work">
      <Panel padded>
        <div className="next-job">
          {mine ? (
            <>
              <span className="next-job__text">
                <span className="next-job__title">{mine.procedureName}</span>
                <span className="muted">
                  {mine.fleetNumber ?? mine.typeName} · step {Math.min(mine.answered + 1, mine.steps)} of {mine.steps}
                </span>
              </span>
              <Link to={{ name: 'execution', id: mine.id }} className="button primary">
                Continue
              </Link>
            </>
          ) : ready ? (
            <>
              <span className="next-job__text">
                <span className="next-job__title">
                  {ready.ready} × {ready.typeName} ready to build
                </span>
                <span className="muted">Parts are on the shelf.</span>
              </span>
              <Link to={{ name: 'work' }} className="button primary">
                Pick one up
              </Link>
            </>
          ) : (
            <>
              <span className="next-job__text">
                <span className="next-job__title">Nothing waiting for you</span>
                <span className="muted">Builds and jobs show up here when there’s something to do.</span>
              </span>
              <Link to={{ name: 'work' }} className="button">
                Open Work
              </Link>
            </>
          )}
        </div>
      </Panel>
    </Section>
  )
}
